import decode from 'jwt-decode';
import { useAuthQuery } from 'hooks/queries/useAuthQuery';
import { UserPermission } from 'models/userPermission';

export interface JwtAccessToken {
  aud: string[];
  azp: string;
  exp: number;
  gty: string;
  iat: number;
  iss: string;
  permissions: UserPermission[];
  scope: string;
  sub: string;
}

export const useAuthTokenDataQuery = () => {
  const { data } = useAuthQuery();

  return data ? decode<JwtAccessToken>(data.access_token) : undefined;
};
